import 'prop-types';
import React from 'react';
import { jsx } from '@emotion/core';

var ResizeHandle = function ResizeHandle(_ref) {
  var field = _ref.field;
  var width = field.width,
      height = field.height;
  var x = field.x,
      y = field.y;
  return jsx(React.Fragment, null, jsx("polygon", {
    points: "\n          ".concat(x + width, ",").concat(y + height, "\n          ").concat(x + width - 20, ",").concat(y + height, "\n          ").concat(x + width, ",").concat(y + height - 20, "\n        "),
    fill: "transparent",
    className: "resize-handle"
  }), jsx("line", {
    x1: x + width - 5,
    y1: y + height - 2,
    x2: x + width - 2,
    y2: y + height - 5,
    stroke: "slategray",
    className: "resize-handle"
  }), jsx("line", {
    x1: x + width - 10,
    y1: y + height - 2,
    x2: x + width - 2,
    y2: y + height - 10,
    stroke: "slategray",
    className: "resize-handle"
  }));
};

ResizeHandle.displayName = "ResizeHandle";
export default ResizeHandle;